import React from "react";
import { ArrowRight } from "lucide-react";

const suggestedPosts = Array.from({ length: 4 }).map(() => ({
  title: "How to Stay Safe While Traveling Solo",
  date: "July 22, 2026",
  readTime: "5 min read",
  image: "/img/blog/related-post.svg",
}));

export default function YouMightAlsoLike() {
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 py-6">
      <h2 className="text-2xl font-extrabold text-slate-900 mb-5">
        You Might Also Like
      </h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {suggestedPosts.map((post, i) => (
          <div
            key={i}
            className="bg-white border border-slate-100 shadow-sm rounded-2xl overflow-hidden"
          >
            <div className="h-32 bg-slate-200">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h4 className="font-semibold text-slate-900 text-sm leading-snug mb-2">
                {post.title}
              </h4>
              <div className="flex items-center justify-between">
                <p className="text-xs text-slate-400">
                  {post.date}
                  <br />
                  {post.readTime}
                </p>
                <button
                  aria-label="Read post"
                  className="w-8 h-8 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0 hover:bg-purple-100 transition-colors"
                >
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
